// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2tBsK","top":"styles_top__3MVzV"};